if (!customElements.get("product-tabs-section")) {
  customElements.define(
    "product-tabs-section",
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId; 
  
        this.perPage =
          window.innerWidth < 1025
            ? parseInt(this.dataset.firstProductsMb, 10)
            : parseInt(this.dataset.firstProducts, 10);

        this.tabButtons = Array.from(this.querySelectorAll(".tab-links"));
        this.slider = this.dataset.slider;
        this.tabResults = {};
        this.currentIndex = {};
      }
  
      connectedCallback() {
        this.classList.remove("hidden");
        this.initTabs();
      }
  
      initTabs() {
        this.tabButtons.forEach((btn) => {
          btn.addEventListener("click", (event) => {
            event.preventDefault();
            this.onTabClick(btn);
          });
          
        });
  
        let activeTab = this.tabButtons.find((btn) =>
          btn.classList.contains("active")
        );
        if (!activeTab && this.tabButtons.length) {
          activeTab = this.tabButtons[0];
          activeTab.classList.add("active");
          activeTab.classList.add("loadeded");
        }
  
        if (activeTab) {
          this.loadTab(activeTab);
          const targetClass = activeTab.dataset.tabContent;
          const tabContainer = this.querySelector(`.${targetClass}`);
          if (tabContainer) {
            tabContainer.style.display = "block";
          }
        }
      }
  
      async onTabClick(clickedButton) {
        if (clickedButton.classList.contains("active")) return;
        
        
        this.tabButtons.forEach((btn) => btn.classList.remove("active"));
        clickedButton.classList.add("active");

        if (!clickedButton.classList.contains("loaded")) {
          await this.loadTab(clickedButton);
        };
        
        this.hideAllTabContents();

        const targetClass = clickedButton.dataset.tabContent;
        const tabContainer = this.querySelector(`.${targetClass}`);
        if (tabContainer) {
          tabContainer.style.display = "block";
        }
      }
  
      hideAllTabContents() {
        this.tabButtons.forEach((btn) => {
          const targetClass = btn.dataset.tabContent;
          const tabContainer = this.querySelector(`.${targetClass}`);
          if (tabContainer) {
            tabContainer.style.display = "none";
          }
        });
      }
  
      async loadTab(tabButton) {
        tabButton.classList.add("loaded");
        const collectionHandle = tabButton.dataset.collectionHandle;
        const targetClass = tabButton.dataset.tabContent;
        const tabContainer = this.querySelector(`.${targetClass}`);
        if (!tabContainer) return;

        tabContainer.classList.add("is-loading");

        await this.fetchProducts(collectionHandle);

        const productGrid = tabContainer.querySelector(".js-tab-content");
        if (productGrid) {
          this.displayProducts(collectionHandle, productGrid);
        }
      
        tabContainer.classList.remove("is-loading");

      }
  
      async fetchProducts(collectionHandle) {
        const url = `/collections/${collectionHandle}?section_id=${this.sectionId}`;
        try {
          const response = await fetch(url);
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const elementWrapper = doc.getElementById(this.sectionId);
          if (elementWrapper) {
            const results = Array.from(
              elementWrapper.querySelectorAll(".js-pagination-result")
            );
            this.tabResults[collectionHandle] = results;

            this.currentIndex[collectionHandle] = 0;
          } else {
            this.tabResults[collectionHandle] = [];
          }
        } catch (error) {
          this.tabResults[collectionHandle] = [];
        }
      }
  
      displayProducts(collectionHandle, gridElement) {
        gridElement.innerHTML = "";
        const results = this.tabResults[collectionHandle] || [];
  
        const itemsToShow = Math.min(results.length, this.perPage);
        const fragment = document.createDocumentFragment();
  
        for (let i = 0; i < itemsToShow; i++) {
          const clonedNode = results[i].cloneNode(true);
          if (this.slider) {
            clonedNode.classList.add("swiper-slide");
          }
          fragment.appendChild(clonedNode);
        }
  
        gridElement.appendChild(fragment);
  
      }
    }
  );
}